import React from "react";
import Sitemap from "../../components/global/sitemap";

export default function SitemapPage() {
    return <Sitemap />;
}